var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "flex-grow-1 d-flex flex-column",
    "class": {
      'graph-mobile-compact': _vm.mobileCompact
    },
    attrs: {
      "elevation": _vm.elevation
    }
  }, [_vm.title || _vm.$slots.title ? _c('v-card-title', {
    staticClass: "pb-0 d-flex flex-wrap flex-sm-nowrap align-center"
  }, [_vm.title ? _c('div', {
    staticClass: "d-flex align-center flex-grow-1 ellipsis"
  }, [_c('span', {
    staticClass: "mr-4"
  }, [_vm._v(_vm._s(_vm.title))])]) : _vm._e(), _vm._t("title"), _vm.mobileCompact && _vm.$vuetify.breakpoint.xsOnly && _vm.showPeriodSelect ? _c('v-btn', {
    attrs: {
      "icon": "",
      "aria-label": _vm.$translate('settings')
    },
    on: {
      "click": function click($event) {
        _vm.settingsOpen = true;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-tune-variant")])], 1) : _vm._e(), _vm.showPeriodSelect && !(_vm.mobileCompact && _vm.$vuetify.breakpoint.xsOnly) ? _c('Select', {
    staticClass: "flex-grow-0 mb-2 mb-sm-0 mt-2 mt-sm-0 w-100 w-sm-auto ml-0 ml-sm-4",
    attrs: {
      "value": _vm.preset,
      "outlined": true,
      "dense": true,
      "clearable": false,
      "options": _vm.periods
    },
    on: {
      "input": function input($event) {
        return _vm.$emit('preset-changed', $event);
      }
    }
  }) : _vm._e()], 2) : _vm._e(), _c('v-dialog', {
    attrs: {
      "max-width": "480"
    },
    model: {
      value: _vm.settingsOpen,
      callback: function callback($$v) {
        _vm.settingsOpen = $$v;
      },
      expression: "settingsOpen"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(_vm._s(_vm.title))]), _c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('Select', {
    attrs: {
      "value": _vm.preset,
      "outlined": true,
      "dense": true,
      "clearable": false,
      "options": _vm.periods
    },
    on: {
      "input": function input($event) {
        return _vm.$emit('preset-changed', $event);
      }
    }
  })], 1), _c('v-card-actions', {
    staticClass: "pa-4"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function click($event) {
        _vm.settingsOpen = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.$translate('close')))])], 1)], 1)], 1), _c('v-card-text', {
    staticClass: "flex-grow-1 d-flex flex-column"
  }, [!_vm.isEmpty && !_vm.loading ? _c(_vm.chartComponent, {
    key: JSON.stringify(_vm.chartData),
    tag: "component",
    attrs: {
      "x-axis-type": _vm.xAxisType,
      "y-axis-type": _vm.yAxisType,
      "unit": _vm.unit,
      "height": _vm.height,
      "width": "100%",
      "chart-data": _vm.chartData || {},
      "aspect-ratio": _vm.aspectRatio,
      "chart-id": _vm.chartId
    }
  }) : _vm._e(), _vm.loading ? _c('Loading', {
    attrs: {
      "absolute": false,
      "size": _vm.height
    }
  }) : _vm.isEmpty ? _vm._t("empty", function () {
    return [_c('div', {
      staticClass: "flex-grow-1 my-12 d-flex flex-column justify-center align-center"
    }, [_c('MasterSvg', {
      attrs: {
        "use": _vm.emptyIcon
      }
    }), _c('div', {
      staticClass: "mt-2"
    }, [_vm._v(_vm._s(_vm.$translate("noData")))])], 1)];
  }) : _vm._e()], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }